export default "__VITE_ASSET__4127ce11__"